module.exports = __webpack_public_path__ + "static/media/winter-wizard-jam.tar.e3091107.gz";